import {
	EnhancedRadioGroupRHFWithLabel,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";

import { BillingSlabsInput } from "../BillingSlabLayout";
import { FC } from "react";

interface IBillingProfileSlabsFieldsPanel extends ITest {}

export const BillingProfileSlabsFieldsPanel: FC<
	IBillingProfileSlabsFieldsPanel
> = ({ testId }) => {
	return (
		<>
			<EnhancedRadioGroupRHFWithLabel
				name="chargesType"
				selectedValue="flat slab charges"
				key="chargesType"
				testId={testId}
				disabled={false}
				options={[
					{
						label: "Slab Charges",
						id: "slab-charges",
						value: "slab charges",
					},
					{
						label: "Flat Slab Charges",
						id: "flat-slab-charges",
						value: "flat slab charges",
					},
				]}
				label="Apply Charges"
				labelPosition={LabelPosition.Left}
				// labelColumns={2}
				// fieldColumns={10}
			/>
			<BillingSlabsInput
				id="monthlySlabs"
				label="Slabs"
				defaultValue={1}
				readOnly={true}
				numberField={false}
			/>
			<BillingSlabsInput
				id="monthlySlabsCharges"
				label="Monthly Fees"
				defaultValue=""
				readOnly={false}
			/>
			<BillingSlabsInput
				id="ddSlabs"
				label="DD Slabs"
				defaultValue={1}
				readOnly={true}
				numberField={false}
			/>
			<BillingSlabsInput
				id="ddSlabsCharges"
				label="DD Fees"
				defaultValue=""
				readOnly={false}
			/>
			<BillingSlabsInput
				id="chqSlabs"
				label="CHQ Slabs"
				defaultValue={1}
				readOnly={true}
				numberField={false}
			/>
			<BillingSlabsInput
				id="chqSlabsCharges"
				label="CHQ Fees"
				defaultValue=""
				readOnly={false}
			/>
			<BillingSlabsInput
				id="ddChqSlabs"
				label="DD/CHQ Slabs"
				defaultValue={1}
				readOnly={true}
				numberField={false}
			/>
			<BillingSlabsInput
				id="ddChqSlabsCharges"
				label="DD/CHQ Fees"
				defaultValue=""
				readOnly={false}
			/>
		</>
	);
};
